import * as React from "react";

function IconSearch(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 26 26"
            {...props}
        >
            <path
                d="M13.014 2.217c2.128.503 3.94 1.827 5.1 3.73a8.537 8.537 0 011.036 6.341 8.465 8.465 0 01-1.69 3.507c.176.105.338.243.476.414l4.656 5.785c.592.736.53 1.814-.118 2.474l-.12.112a1.763 1.763 0 01-2.52-.244l-4.655-5.783a1.85 1.85 0 01-.333-.638 7.897 7.897 0 01-5.498.677c-2.13-.503-3.939-1.828-5.098-3.73A8.536 8.536 0 013.21 8.52c.49-2.186 1.779-4.046 3.63-5.236a7.943 7.943 0 016.173-1.067zm-1.846 1.24a6.569 6.569 0 00-3.574 1.06c-1.532.985-2.597 2.522-3.002 4.33a7.06 7.06 0 00.859 5.244c.958 1.572 2.454 2.667 4.215 3.082 1.76.417 3.57.104 5.102-.882a6.892 6.892 0 003.001-4.329 7.049 7.049 0 00-.857-5.242c-.958-1.574-2.455-2.668-4.215-3.085a6.698 6.698 0 00-1.529-.178z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
}

export default IconSearch;
